import { Text, makeStyles } from '@rneui/themed'
import { ManagementTeamActionsToastType } from 'management_team/management_actions_context'
import { View } from 'react-native'
import { ToastProps } from 'react-native-toast-notifications/lib/typescript/toast'
interface CustomToastProps {
  message?: string
  type?: ManagementTeamActionsToastType
}

export default function CustomToast(props: ToastProps) {
  const { message, type } = props.data as CustomToastProps
  const styles = useStyles(type)
  return (
    <View style={styles.toastContainer}>
      <Text style={styles.title}>{props.message}</Text>
      <Text style={styles.text}>{message}</Text>
    </View>
  )
}

const useStyles = makeStyles((theme, type: ManagementTeamActionsToastType) => ({
  toastContainer: {
    backgroundColor:
      theme.mode === 'dark' ? theme.colors.grey7 : theme.colors.grey6,
    padding: 10,
    borderWidth: 0.5,
    borderTopColor: theme.colors.grey4,
    borderRightColor: theme.colors.grey4,
    borderBottomColor: theme.colors.grey4,
    borderRadius: 15,
    marginBottom: 50,
    marginHorizontal: 15,
    borderLeftWidth: 6,
    borderLeftColor:
      type === 'add' || type === 'update'
        ? theme.colors.success
        : theme.colors.primary,
  },
  text: { color: theme.colors.black },
  title: {
    color: theme.colors.black,
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 5,
  },
}))
